
import ProductCardAlt from '../shop/productCardAlt.vue';

export default {
  name: 'ProductSliderItemAlt',

  components: {
    ProductCardAlt,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
